import type { FormLayout, FormLayoutPage } from '../../../../../forms'
import { BasicInfoLayout } from './basic-info'
import { buildLayoutWithCommonSections, layoutFields } from './helpers'
import { NotesLayout } from './notes'

const InclinedElevatorLayout: FormLayoutPage = {
  key: 'inclined-elevator',
  title: 'Inclined Elevator',
  contents: [
    layoutFields.speed,
    layoutFields.condition,
    layoutFields.accumulatedWear,
    layoutFields.design,
    layoutFields.inherentQuality,
    layoutFields.usage,
    layoutFields.environment,
    layoutFields.technology,
    layoutFields.drivingMachineInstallYear,
    layoutFields.operationalControllerInstallYear,
    layoutFields.typeOfMotorController,
    layoutFields.hasCounterWeights,
    layoutFields.hasCounterweightSafeties,
    layoutFields.governorType,
    layoutFields.brakeType,
    layoutFields.driveType,
    layoutFields.execSoftwareRevision,
    layoutFields.controllerManufacturerAndModel,
    layoutFields.drivingMachineManufacturerAndModel,
    layoutFields.suspensionMeansType,
    layoutFields.suspensionMembersInstallYear,
    layoutFields.hasHoistwayDoorSwitch,
    layoutFields.hasGateSwitch,
    layoutFields.hasEmergencyPower,
    layoutFields.guideType,
    layoutFields.interlocksInstallYear,
    layoutFields.hoistwayDoorType,
    layoutFields.carDoorType,
    layoutFields.numLandings,
    layoutFields.numberOfOpenings,
    layoutFields.doorOpeningMethod,
    layoutFields.doorPanelsType,
    layoutFields.bufferType,
  ],
}

export const InclinedElevatorFormLayout: FormLayout =
  buildLayoutWithCommonSections([
    BasicInfoLayout,
    InclinedElevatorLayout,
    NotesLayout,
  ])
